import { getDefaultMetricDisplay } from "helpers/metrics"
import { METRIC_TYPES } from "helpers/metrics/constants"
import { InstrumentWithMetadata } from "helpers/types/instruments/metadata"
import {
  getPerformanceSummaryRowMetricIds,
  getRiskSummaryRowMetricIds,
} from "connected-components/asset-view/helpers/summary-row-metric-ids"

export interface SummaryDuplicateMetricIdsOptions {
  betaFields?: string[]
  betaInstrument?: InstrumentWithMetadata | null
  isIntradayEnabled?: boolean
  selectedMetricDisplay?: string
}

export function getSummaryDuplicateMetricIds(
  flattenedMetrics: Record<string, unknown> | null | undefined,
  {
    betaFields = [],
    betaInstrument = null,
    isIntradayEnabled = false,
    selectedMetricDisplay = METRIC_TYPES.CURRENCY_PERFORMANCE,
  }: SummaryDuplicateMetricIdsOptions = {},
) {
  if (!flattenedMetrics) {
    return []
  }

  const candidateMetricIds = [
    ...getPerformanceSummaryRowMetricIds(flattenedMetrics, selectedMetricDisplay),
    ...getRiskSummaryRowMetricIds(flattenedMetrics),
  ]

  const betaDisplayId = getDefaultMetricDisplay("beta")
  const betaFieldIds = [...betaFields]
  if (betaInstrument && !isIntradayEnabled && !betaFieldIds.includes("dynamicPredicted")) {
    betaFieldIds.push("dynamicPredicted")
  }
  candidateMetricIds.push(
    ...betaFieldIds.map((betaFieldId) => `beta.${betaFieldId}.${betaDisplayId}`),
  )

  return candidateMetricIds.filter((metricId) => flattenedMetrics[metricId])
}
